import { type Error, type FetchWalletMeBalanceParams, minutesToMs } from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchWalletMeBalance, type FetchWalletMeBalanceType } from '../api/wallet';

export const walletsBalanceQueryKey = ['wallets', 'balance', 'rewardPointBalance'];

/**
 *
 * Contains the balance of BOTH custodial and nonCustodial Wallets.
 * */
export const useWalletsBalanceQuery = (
	queryFnParams: FetchWalletMeBalanceParams,
	options?: Omit<UseQueryOptions<FetchWalletMeBalanceType, Error>, 'queryFn' | 'queryKey'>
) =>
	useQuery<FetchWalletMeBalanceType, Error>({
		queryFn: async () => fetchWalletMeBalance(queryFnParams),
		queryKey: [...walletsBalanceQueryKey, queryFnParams],
		refetchInterval: minutesToMs(5),
		staleTime: minutesToMs(5),
		...options
	});
